import { NodeViewWrapper } from '@tiptap/react';
import { HeroBlock, ReferenceCardBlock } from './ContentBlockVisuals.jsx';
export function HeroNodeView({ node }) {
  return <NodeViewWrapper contentEditable={false}><HeroBlock attrs={node.attrs} authoring/></NodeViewWrapper>;
}
export function ReferenceCardNodeView({ node }) {
  return <NodeViewWrapper contentEditable={false}><ReferenceCardBlock type={node.type.name} attrs={node.attrs} authoring/></NodeViewWrapper>;
}
